// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { State } from '@app/access-management/state';
import { Observable, of } from 'rxjs';
import { Group, GroupUser } from '@app/access-management/core/models/groups.model';
import { GroupDetail } from '../../core/models/groups.model';
import { Loadable} from '@app/core';
import { selectGroupDetailsLoadable, selectGroupDetail } from './group-details.selectors';
import { LoadingGroupDetailsAction } from './group-details.actions';
import { filter, map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class GroupDetailsFacadeService {

    loadableGroupDetail$: Observable<Loadable | undefined> = of();
    groupDetails$: Observable<Group | undefined> = of();
    groupUsers$: Observable<GroupUser[] | undefined> = of();

    constructor(private store: Store<State>) {}

    initialize (groupId: string) {

        this.refreshGroup(groupId);

        this.loadableGroupDetail$ = this.store.pipe(select(selectGroupDetailsLoadable(groupId)));

        const groupDetail$ = this.store.pipe(
                select(selectGroupDetail(groupId)),
                filter<GroupDetail>(groupDetail => !!groupDetail));

        this.groupDetails$ = groupDetail$.pipe(map((groupDetail: GroupDetail) => groupDetail.group));
        this.groupUsers$ = groupDetail$.pipe(map((groupDetail: GroupDetail) => groupDetail.users));
    }

    refreshGroup(groupId: string) {
        this.store.dispatch(new LoadingGroupDetailsAction(groupId));
    }

}




// WEBPACK FOOTER //
// ./src/app/access-management/state/group-details/group-details.facade.ts